declare global {
  interface Window {
    /** A/Bテストツール（VWO）のバリエーション側だけが立てる実験フラグ */
    gssktExperiment?: {
      entryRegisterModal?: boolean;
    };
  }
}

/**
 * 募集一覧の登録モーダルを出すかどうか。
 * VWO のバリエーション側が `window.gssktExperiment.entryRegisterModal = true` を立て、
 * フラグが無いコントロール側は従来どおりログイン画面へ遷移する。
 * VWO は非同期に読み込まれるため、描画時ではなくクリック時に呼ぶこと。
 */
export const isEntryRegisterModalExperimentEnabled = (): boolean =>
  typeof window !== 'undefined' &&
  window.gssktExperiment?.entryRegisterModal === true;
